module.exports = __webpack_public_path__ + "static/media/PurCo.7a855700.svg";